import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable'
import { UserData } from './data.model';
import {Subject} from 'rxjs'

import { environment } from 'src/environments/environment';
import { EntityWebsiteModel } from '../components/pages/schoolSetup/entityWesiteCrud/entityWebsiteCrud.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  getCoursesByTeacher(entityId: string, session: any, dateWise: any, teacher: any, isAdmin: any) {
    throw new Error('Method not implemented.');
  }
  browserDomain : string = window.origin;    //Dynamic
  config
  // domain : string = environment.domain;             // Live server domian "https://api.odpay.in";
  domain : string = this.getDomain(this.browserDomain);
  odPayDomain: string = environment.odPayDomain;
  port : string = environment.port;
  api: string = environment.api
  URL = this.getUrl()

  getUrl()
  {
    // if(this.domain == 'https://okiedokiepay-api-3ztr52punq-em.a.run.app')
    //   {
    //     return  this.domain +'/'+ this.api;
    //   }else{
        return  this.domain +this.port +this.api;
     // }
   
  }
  LoginURL(){  
    let url = this.config['auth'] +this.port ;
    const FinalURL = url + "login"; 
    return FinalURL ;
    
  }
  studentLoginURL(){
    let url = this.config['auth'] +this.port ;
    const FinalURL = url + "studentLogin"; 
    return FinalURL ;  
 }
  userToken = localStorage.getItem('token');

  URLAddress(address,value){

      let url = (this.config[value]?this.config[value]:this.config['other']) +this.port +this.api;
    const FinalURL = url + address;
    return FinalURL; 
  }
  getDomain(browserDomain){
    if(browserDomain.includes('cp.mukand.org'))
      {
        this.config = environment.cpconfig
        return 'https://cp-api.odpay.in'
      }
      else if(browserDomain.includes('school.oderp.in'))
        {
        this.config = environment.s1config
          return 'https://s1-api.odpay.in'
        }
       else  if(browserDomain.includes('campus.oderp.in'))
          {
            this.config = environment.c1config
            return 'https://c1-api.odpay.in'
          }
          else if(browserDomain.includes('campus.odpay.in'))
            {
              this.config = environment.c2config
              return 'https://c2-api.odpay.in'
            }
           else if(browserDomain.includes('school.odpay.in'))
              {
                this.config = environment.s2config
                return 'https://s2-api.odpay.in'
              }
              else{
                this.config = environment.config
                return environment.domain
              }
  }


  //printGlobal


// ApiAdd : any = ApiUrl.domain;
  constructor(private http: HttpClient) {



   }
  getToken(){
    return localStorage.getItem('token')
  }
  getODPayToken(){
    return localStorage.getItem('studentToken')
  }

  login(authData){
    // alert(this.LoginURL);
    return this.http.post<any>(this.LoginURL(), authData);
  }
  loggedIn() {
    return !!localStorage.getItem('token')    
  }
  getUserDetails()
  {
    return JSON.parse(JSON.stringify(localStorage.getItem('deviceInfo')))
  }
  // // Entity Data
  // getEntityList(): Observable<UserData[]>{
  //   return this.http.get<UserData[]>(this.URLAddress('/list/entity'))
  // }
  
  // addEntityData(entityData): Observable<UserData[]>{
  //   return this.http.post<UserData[]>(this.URLAddress("/add/entity"), entityData);
  // }

  
  
}
